'use client';
import React, { useEffect, useState } from 'react';
import { Skeleton } from 'primereact/skeleton';
import Link from 'next/link';

const formatSlugToTitle = (slug) => {
    if (!slug) return '';
    return slug.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
};

export const BreadCrumbMenu = ({ data }) => {
    const category      = data?.category?.slug  || '';
    const categoryTitle = data?.category?.title || '';
    const productTitle  = formatSlugToTitle(data.slug);

    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const t = setTimeout(() => setLoading(false), 1000);
        return () => clearTimeout(t);
    }, []);

    if (loading) {
        return (
            <div className="flex align-items-center gap-2">
                <Skeleton height="20px" width="20px" />
                <Skeleton height="20px" width="80px" />
                <Skeleton height="20px" width="200px" />
            </div>
        );
    }

    const sep = (
        <i className="pi pi-angle-right flex-shrink-0" style={{ fontSize: '0.65rem', color: '#9ca3af', margin: '0 3px' }} />
    );

    return (
        <nav
            aria-label="breadcrumb"
            style={{
                display: 'flex',
                alignItems: 'center',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                maxWidth: '100%',
                fontSize: '0.8rem',
            }}
        >
            {/* Home */}
            <Link href="/" aria-label="Home" style={{ flexShrink: 0, color: 'var(--primary-color)', display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                <i className="pi pi-home" aria-hidden="true" style={{ fontSize: '0.78rem' }} />
            </Link>

            {sep}

            {/* Category */}
            {categoryTitle && (
                <>
                    <Link
                        href={`/${category}`}
                        style={{
                            flexShrink: 0,
                            color: 'var(--primary-color)',
                            textDecoration: 'none',
                            fontWeight: 500,
                            maxWidth: '30%',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}
                    >
                        {categoryTitle}
                    </Link>
                    {sep}
                </>
            )}

            {/* Product name — truncates */}
            <span
                style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    color: '#374151',
                    fontWeight: 400,
                    minWidth: 0,
                    flex: 1,
                }}
                title={productTitle}
            >
                {productTitle}
            </span>
        </nav>
    );
};
